<template>
  <b-row class="app-section">
    <b-col cols="12" class="landing-page">
      <b-row>
        <b-col cols="12">
        <b-jumbotron class="jumbotron bg-dark" border-variant="dark" >
          <div class="jumbotron-background"></div>
          <b-container class="container">
            <h1 class="jumbotron-header" style="color: #f2f2f2;">
              Interactive Oceans Data Portal</h1>
            <p class="jumbotron-subtitle lead" style="color: #f2f2f2;">
              Welcome to the Interactive Oceans Data Portal!
              Please select an application to visit below.</p>
            <p class="jumbotron-caption lead" style="color: #3995a3;">
              Open data, open access, open science</p>

            <strong style="color: #f2f2f2;">Version:</strong>
            <b-badge
              pill
              id="homepage_badge_appInfo"
              class="badge badge-primary"
              data-v-step="1"
              variant=“primary”
              :to="{ path: '/app-info' }"
              @click="getCardID"
            >{{appVersion}}</b-badge>
            <strong style="color: #f2f2f2;"> | </strong>
            <strong style="color: #f2f2f2;">Total Data: </strong>
            <b-badge
              pill
              class="badge badge-primary"
              variant=“primary”
            >
              {{dataInfo.size}}</b-badge>
            <strong style="color: #f2f2f2;"> | </strong>
            <strong style="color: #f2f2f2;">Number of Instruments: </strong>
            <b-badge
              pill
              id="homepage_badge_instInfo"
              class="badge badge-primary"
              data-v-step="2"
              variant=“primary”
              :to="{ path: '/data-info' }"
              @click="getCardID"
            >{{dataInfo.num_instruments}}</b-badge>
          </b-container>
        </b-jumbotron>
        </b-col>
      </b-row>
      <div id="v-step-3">
      <hr class="my-4">
      <b-row class="d-flex align-items-center" style="width: 90%; margin: 0 auto;
      margin-bottom: 2%;">
        <b-card-group>
          <b-col cols="6">
            <b-btn
              @click="getCardID"
              class="parent"
              variant="link"
              :to="{ path: '/map' }"
            >
              <b-card
                class="child"
                no-body
                :img-src="mapAppImg"
                img-alt="Screenshot of data portal's map"
                img-top
                tag="article"
              >
                <p
                  id="homepage_map_card"
                  class="card-title first"
                >Interactive Map Application</p>
              </b-card>
            </b-btn>
          </b-col>
          <!-- <b-col cols="4">
            <b-btn
              @click="getCardID"
              class="parent"
              variant="link"
              :to="{ path: '/plot' }"
            >
              <b-card
                class="child"
                no-body
                :img-src="dataVizAppImg"
                img-alt="Image"
                img-top
                tag="article"
              >
                <p
                  id="homepage_plot_card"
                  class="card-title first"
                >Data Visualization Application</p>
              </b-card>
            </b-btn>
          </b-col> -->
          <b-col cols="6">
            <b-btn
              @click="getCardID"
              class="parent"
              variant="link"
              :href="oceanSciencesNotebook"
              target="_blank"
            >
              <b-card
                class="child"
                no-body
                :img-src="oceanSciencesNB"
                img-alt="Image"
                img-top
                tag="article"
              >
                <p
                  id="homepage_OS_notebook_card"
                  class="card-title first"
                >Ocean Sciences Notebook</p>
              </b-card>
            </b-btn>
          </b-col>
        </b-card-group>
      </b-row>
      <b-row class="d-flex align-items-center" style="width: 90%; margin: 0 auto;
      margin-bottom: 2%;" align-h="center">
        <b-card-group>
          <b-col cols="3">
            <b-btn
              @click="getCardID"
              class="parent"
              v-b-toggle.accordion-1
              variant="link"
            >
              <b-card
                class="child"
                no-body
                :img-src="futureFeaturesImg"
                img-alt="Image"
                img-top
                tag="article"
              >
                <p
                  id="homepage_futureFeatures_card"
                  class="card-title second"
                >Future Features</p>
              </b-card>
            </b-btn>
          </b-col>
          <b-col cols="3">
            <b-btn
              @click="getCardID"
              class="parent"
              variant="link"
              :href="OOIURL"
              target="_blank"
            >
              <b-card
                class="child"
                no-body
                :img-src="interactiveOceansImg"
                img-alt="Image"
                img-top
                tag="article"
              >
                <p
                  id="homepage_staticHomepage_card"
                  class="card-title second"
                >Interactive Oceans Website</p>
              </b-card>
            </b-btn>
          </b-col>
          <b-col cols="3">
            <b-btn
              @click="getCardID"
              class="parent"
              variant="link"
              :href="OOIURLExpedition"
              target="_blank"
            >
              <b-card
                class="child"
                no-body
                title="Expedition Information"
                :img-src="expeditionInfoImage"
                img-alt="Image"
                img-top
                tag="article"
              >
                <p
                  id="homepage_expedition_card"
                  class="card-title second"
                >Expedition Information</p>
              </b-card>
            </b-btn>
          </b-col>
          <b-col cols="3">
            <b-btn
              @click="getCardID"
              class="parent"
              variant="link"
              :href="OOIURLGallery"
              target="_blank"
            >
              <b-card
                class="child"
                no-body
                :img-src="mediaGalleryImg"
                img-alt="Image"
                img-top
                tag="article"
              >
                <p
                  id="homepage_mediaGallery_card"
                  class="card-title second"
                >Media Gallery</p>
              </b-card>
            </b-btn>
          </b-col>
        </b-card-group>
      </b-row>
      </div>
      <hr class="my-4">
      <b-row align-h="center">
        <b-collapse id="accordion-1" class="mt-2" >
          <future-features></future-features>
        </b-collapse>
      </b-row>
      <div id="v-step-4">
      <b-row id="news-and-updates" align-h="center">
        <b-col cols="10">
          <news-and-updates></news-and-updates>
        </b-col>
      </b-row>
      </div>
      <hr class="my-4">
      <!-- MOUNT TOUR | name can be used anywhere to start the tour -->
      <v-tour
        :name="tourName"
        :steps="steps"
        :callbacks="tourCallbacks"
        :options="tourOptions">
      </v-tour>
    </b-col>
  </b-row>
</template>
<script>
import axios from 'axios';
import mapAppImg from '../../assets/img/landingpage-img/mapAppImg.png';
import dataVizAppImg from '../../assets/img/landingpage-img/dataVizAppImg.png';
import oceanSciencesNB from '../../assets/img/landingpage-img/oceanSciencesNB.png';
import interactiveOceansImg from '../../assets/img/landingpage-img/IOHomepage.png';
import expeditionInfoImage from '../../assets/img/landingpage-img/expeditionPageImg.png';
import mediaGalleryImg from '../../assets/img/landingpage-img/mediaGalleryImg.png';
import futureFeaturesImg from '../../assets/img/landingpage-img/futureFeatures.png';

import futureFeatures from './futureFeatures';
import newsAndUpdates from './newsAndUpdates';

export default {
  components: {
    'future-features': futureFeatures,
    'news-and-updates': newsAndUpdates,
  },
  data() {
    return {
      appVersion: process.env.APPVERSION,
      ffClick: false,
      mapAppImg,
      dataVizAppImg,
      oceanSciencesNB,
      interactiveOceansImg,
      expeditionInfoImage,
      mediaGalleryImg,
      futureFeaturesImg,
      oceanSciencesNotebook: `${process.env.JUPYTERNOTEBOOK}`,
      OOIURL: `${process.env.OOIURL}`,
      OOIURLExpedition: `${process.env.OOIURL}/expeditions`,
      OOIURLGallery: `${process.env.OOIURL}/gallery`,
      dataInfo: '',
      tourName: 'homeTour',
      tourCallbacks: {
        onStart: this.tourStart,
        onFinish: this.tourFinish,
        onSkip: this.tourSkip,
      },
      tourOptions: { useKeyboardNavigation: false },
      steps: [
        {
          target: '#v-step-0',
          content: 'Navigate through different applications by using the navbar, including the map, data visualization tools, and Jupyter notebooks.',
          params: {
            highlight: false,
          },
        },
        {
          target: '[data-v-step="1"]',
          content: 'Click to find information regarding data portal version and changelog.',
          params: {
            highlight: false,
            enableScrolling: false,
          },
        },
        {
          target: '[data-v-step="2"]',
          content: 'Click to find information regarding instruments and their different streams.',
          params: {
            highlight: false,
            enableScrolling: false,
          },
        },
        {
          target: '#v-step-3',
          content: 'Select a navigation card to visit the various parts of the site.',
          params: {
            highlight: true,
          },
        },
        {
          target: '#v-step-4',
          content: 'See news articles and updates to Interactive Oceans here.',
          params: {
            highlight: true,
          },
        },
      ],
    };
  },
  mounted() {
    this.retriveDataInfo();
    if (!localStorage.getItem(this.tourName)) {
      // Access the desired tour
      this.$tours[this.tourName].start();
      localStorage.setItem(this.tourName, true);
    }
  },
  methods: {
    // Gets the app info from json
    retriveDataInfo() {
      axios
        .get('https://ooi-data.s3.us-west-2.amazonaws.com/stats.json')
        .then((response) => {
          this.dataInfo = response.data;
        });
    },
    // To know if a user started a page's tutorial
    tourStart() {
      this.$ga('event', 'tutorial_begin', { tour: this.tourName });
    },
    // To know if a user finished or completed a page's tutorial
    tourFinish() {
      this.$ga('event', 'tutorial_complete', { tour: this.tourName });
    },
    // To know if a user skipped a page's tutorial
    tourSkip() {
      this.$ga('event', 'tutorial_skip', { tour: this.tourName });
    },
    // To get the id of the clicked element for GA
    getCardID(event) {
      this.$ga('event', event.target.id);
    },
  },
};
</script>
